import { render, staticRenderFns } from "./CumulativeChart.vue?vue&type=template&id=4b8fa273&"
import script from "./CumulativeChart.vue?vue&type=script&lang=ts&"
export * from "./CumulativeChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports